import React from 'react'
import PropTypes from 'prop-types'

const AppContainer = props => {
    const {
        children,
        className,
        whiteBodyBackground = false,
        ...otherProps
    } = props

    return (
        <React.Fragment>
            {whiteBodyBackground && (
                <style
                    dangerouslySetInnerHTML={{
                        __html: `body{background:white;}`,
                    }}
                />
            )}

            <div
                {...otherProps}
                className={
                    className ? `app-container ${className}` : 'app-container'
                }
            >
                {children}
            </div>
        </React.Fragment>
    )
}

AppContainer.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    whiteBodyBackground: PropTypes.bool,
}

export { AppContainer }
